import { Loader } from '@crehana/ui';
import Loadable from '@crehana/web/Loadable';

const LazyPrivacyPolicy = () => (
  <Loadable
    Loader={
      <div className="w-full h-screen flex justify-center py-24">
        <Loader />
      </div>
    }
    module={() =>
      import(/* webpackChunkName: "legal-privacy-policy" */ './PrivacyPolicy')
    }
  />
);

export default LazyPrivacyPolicy;
